// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   selectedMarket: null,
// };

// const marketSlice = createSlice({
//   name: 'market',
//   initialState,
//   reducers: {
//     setSelectedMarket: (state, action) => {
//       state.selectedMarket = action.payload;
//     },
//     clearSelectedMarket: (state) => {
//       state.selectedMarket = null;
//     },
//   },
// });

// export const { setSelectedMarket, clearSelectedMarket } = marketSlice.actions;
// export default marketSlice.reducer;
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  favoriteMarkets: JSON.parse(localStorage.getItem('favoriteMarkets')) || [],
  marches: [],
  // { [marche_id]: { data: float[], at: timestamp_ms } }
  sparklines: {},
  // { [marche_id]: { value, last_value, at: timestamp_ms } }
  prices: {},
  // { data: [], at: timestamp_ms }
  topVolatiles: { data: [], at: 0 },
};

const marketSlice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    addFavoriteMarket: (state, action) => {
      if (!state.favoriteMarkets.find(market => market.marche_id === action.payload.marche_id)) {
        state.favoriteMarkets.push(action.payload);
        localStorage.setItem('favoriteMarkets', JSON.stringify(state.favoriteMarkets)); // Mettre à jour localStorage
      }
    },
    removeFavoriteMarket: (state, action) => {
      state.favoriteMarkets = state.favoriteMarkets.filter(
        market => market.marche_id !== action.payload.marche_id
      );
      localStorage.setItem('favoriteMarkets', JSON.stringify(state.favoriteMarkets));
    },
    setMarches: (state, action) => {
      state.marches = action.payload;
    },
    // payload: { [marche_id]: { value, last_value, ... } }
    setPricesBatch: (state, action) => {
      const now = Date.now();
      Object.entries(action.payload).forEach(([id, data]) => {
        state.prices[id] = { ...data, at: now };
      });
    },
    setTopVolatiles: (state, action) => {
      state.topVolatiles = { data: action.payload, at: Date.now() };
    },
    // payload: { "marche_id": [float, ...] }
    setSparklinesBatch: (state, action) => {
      const now = Date.now();
      Object.entries(action.payload).forEach(([id, data]) => {
        if (Array.isArray(data) && data.length > 0) {
          state.sparklines[id] = { data, at: now };
        }
      });
    },
  },
});

export const { addFavoriteMarket, removeFavoriteMarket, setMarches, setPricesBatch, setSparklinesBatch, setTopVolatiles } = marketSlice.actions;
export default marketSlice.reducer;
